import { useState, useEffect } from 'react';
import { copyToClipboard } from '../utils/index';
import CardMessage from '../components/card-message';
import { useNavigate } from 'react-router-dom';
import { GuildInfoType } from 'api/type';
import { getGuildInfo, isMaster } from 'api/index';
import { useAtom } from 'jotai';
import {
  isMasterAtom,
  guildIdAtom,
  uidAtom,
  masterInfoAtom,
  dateTypeAtom,
  countdownAtom,
} from 'store';
import { getArgFromUrl } from '../utils/index';
import { Toast } from 'react-vant';
// import Nav from 'components/nav';
import { _T, Nav, jumpWithCurrentParams, useNavHeight } from '@dana/components';

export default function Mine() {
  const h = useNavHeight();
  const [guildInfo, setInfo] = useState<GuildInfoType | null>(null);
  const id = getArgFromUrl('uid') || '';
  const token = getArgFromUrl('token') || '';
  const [isGuildeMaster, setIsGuildMaster] = useAtom(isMasterAtom);
  const [guildId, setGuildId] = useAtom(guildIdAtom);
  const [uid, setUid] = useAtom(uidAtom);
  const [masterInfo, setMasterInfo] = useAtom(masterInfoAtom);

  const [, setDateType] = useAtom(dateTypeAtom);

  const navigate = useNavigate();

  const fetchInfo = async () => {
    const res = await getGuildInfo();
    if (res) {
      setInfo(res);
      setGuildId(res?.guildId);
      setIsGuildMaster(res?.masterId === id);
      setMasterInfo({
        uid: Number(res?.masterId),
        danaId: Number(res?.danaId),
        avatar: res?.masterAvatar,
        guildId: res?.guildId || 0,
        nickName: res?.masterName,
        guildMembers: Number(res?.memberNum) || 0,
      });
      setUid(Number(id));
      setDateType(res?.settleType === 'HALF_MONTH' ? 'HALF_MONTH' : 'month');
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  function copy() {
    copyToClipboard(String(guildInfo?.guildId || 0));
    Toast.info('copy success');
  }

  function goToMembers() {
    navigate(`/members`);
  }

  function goToSearch() {
    navigate(`/invite`);
  }

  function goToData() {
    navigate(`/data`);
  }

  function goToReflect() {
    jumpWithCurrentParams('/reflect');
  }

  function close() {
    (window as any).toFlutter.postMessage(
      JSON.stringify({
        method: 'closeWebView',
      }),
    );
  }

  const [bH, setBH] = useState(375);
  useEffect(() => {
    setBH(292 + h);
  }, [h]);

  return (
    <div className="w-[375px] h-screen overflow-x-hidden overflow-y-auto bg-[#F2F5F5]">
      <div
        className={`relative w-[375px]`}
        style={{
          height: `${bH}px`,
        }}
      >
        <div
          className={`absolute bg-cover blur backdrop-blur-md w-[375px] z-1 top-[0px]`}
          style={{
            backgroundImage: `url(${guildInfo?.cover || guildInfo?.masterAvatar})`,
            height: `${bH}px`,
          }}
        ></div>
        <div
          className={`absolute bg-cover w-[375px] z-2 top-[0px]`}
          style={{
            backgroundImage: `url(${require('asset/imgs/hover.png')})`,
            height: `${bH}px`,
          }}
        ></div>
        <Nav title={_T('公会')} styleType="white" close={true}></Nav>
        <div
          className="relative w-[100px] h-[100px] rounded-[8px] border border-[#F7F7F7] m-auto mt-[12px] bg-cover"
          style={{ backgroundImage: `url(${guildInfo?.cover || guildInfo?.masterAvatar})` }}
        ></div>
        <div
          className="flex justify-center mt-[12px] relative font-sans text-white text-base font-bold leading-5"
          dir="auto"
        >
          {guildInfo?.guildName}
          <div
            className="text-[20px] ml-[7px] w-[20px] h-[20px] bg-cover"
            style={{
              backgroundImage: guildInfo?.guildZone ? `url(${guildInfo?.zoneUrl})` : '',
            }}
          ></div>
        </div>
        <div className="relative flex justify-center mt-[10px]">
          <div className="flex justify-center items-center w-[145px] h-[24px] rounded-[37px] bg-white/10">
            <div
              className="w-[18px] h-[18px] bg-cover"
              style={{
                backgroundImage: `url(${require('asset/imgs/ids.png')})`,
              }}
            ></div>
            <div className="ml-[3px] mr-[1px] text-white font-sanstext-sm font-[590] leading-[18px]">
              {guildInfo?.danaId}
            </div>
            <div
              className="w-[18px] h-[18px] bg-cover"
              onClick={copy}
              style={{
                backgroundImage: `url(${require('asset/imgs/copy.png')})`,
              }}
            ></div>
          </div>
          <div
            className="flex justify-center items-center w-[52px] ml-[6px] mr-[16px] h-[24px] flex-shrink-0 rounded-[37px] bg-white/10"
            onClick={goToMembers}
          >
            <div
              className="w-[18px] h-[18px] bg-cover"
              style={{
                backgroundImage: `url(${require('asset/imgs/person.png')})`,
              }}
            ></div>
            <div className="ml-[6px] text-white font-sans text-sm font-[590] leading-[18px]">
              {guildInfo?.memberNum}
            </div>
          </div>
        </div>
      </div>
      <div
        className="bg-[#F2F5F5] mt-[-7px] pt-[12px] relative flex justify-start items-center flex-col w-[375px] rounded-tl-[8px] rounded-tr-[8px]"
        style={{
          paddingBottom: isGuildeMaster
            ? 'calc(80px + env(safe-area-inset-bottom, 0px))'
            : undefined,
        }}
      >
        <div className="rounded-[8px]">
          <CardMessage
            type="show"
            guildId={guildInfo?.guildId || 0}
            personData={{
              guildName: guildInfo?.guildName || '',
              memberId: String(guildInfo?.danaId || ''),
              nickName: guildInfo?.masterName || '',
              avatar: guildInfo?.masterAvatar || '',
              guildId: guildInfo?.guildId || 0,
              wealthLv: guildInfo?.wealthLv || 0,
              charmLv: guildInfo?.charmLv || 0,
              danaId: guildInfo?.danaId || 0,
              joinTimeStr: '',
              zoneCode: guildInfo?.guildZone || '',
              zoneUrl: guildInfo?.zoneUrl || '',
              inviteType: 1,
              sex: guildInfo?.sex || 0,
              country: guildInfo?.zoneUrl || '',
            }}
          ></CardMessage>
        </div>
        {guildInfo?.roomDayReward && (
          <div
            onClick={() => {
              if (process.env.REACT_APP_ENV === 'development') {
                window.location.href = `http://192.168.0.233/room-reward?rid=${id}&uid=${id}&token=${token}&language=${getArgFromUrl('language')}`;
              } else {
                window.location.href = `https://web.danachatapp.com/room-reward?rid=${id}&uid=${id}&token=${token}&language=${getArgFromUrl('language')}`;
              }
            }}
            className="pl-[12px] pr-[12px] flex justify-between items-center mt-[12px] w-[351px] h-[48px] rounded-[8px] bg-white"
          >
            <div className="flex">
              <div
                className="w-[18px] h-[18px] bg-cover"
                style={{ backgroundImage: `url(${require('asset/imgs/gift.png')})` }}
              ></div>
              <div
                dir="auto"
                className="ml-[6px] text-[#333] font-sans text-[14px] font-bold leading-[18px]"
              >
                {_T('房间奖励')}
              </div>
            </div>
            <div
              className="w-[18px] h-[18px] bg-cover"
              style={{ backgroundImage: `url(${require('asset/imgs/back2.png')})` }}
            ></div>
          </div>
        )}
        <div
          onClick={goToData}
          className="pl-[12px] pr-[12px] flex justify-between items-center mt-[12px] w-[351px] h-[48px] rounded-[8px] bg-white"
        >
          <div className="flex">
            <div
              className="w-[18px] h-[18px] bg-cover"
              style={{ backgroundImage: `url(${require('asset/imgs/computer.png')})` }}
            ></div>
            <div
              dir="auto"
              className="ml-[6px] text-[#333] font-sans text-[14px] font-bold leading-[18px]"
            >
              {_T('数据细节')}
            </div>
          </div>
          <div
            className="w-[18px] h-[18px] bg-cover"
            style={{ backgroundImage: `url(${require('asset/imgs/back2.png')})` }}
          ></div>
        </div>

        {guildInfo?.canWithdraw === 1 && (
          <div
            onClick={goToReflect}
            className="pl-[12px] pr-[12px] flex justify-between items-center mt-[12px] w-[351px] h-[48px] rounded-[8px] bg-white"
          >
            <div className="flex">
              <div
                className="w-[18px] h-[18px] bg-cover"
                style={{ backgroundImage: `url(${require('asset/imgs/withdraw.png')})` }}
              ></div>
              <div
                dir="auto"
                className="ml-[6px] text-[#333] font-sans text-[14px] font-bold leading-[18px]"
              >
                {_T('提现')}
              </div>
            </div>
            <div
              className="w-[18px] h-[18px] bg-cover"
              style={{ backgroundImage: `url(${require('asset/imgs/back2.png')})` }}
            ></div>
          </div>
        )}

        {isGuildeMaster && (
          <div
            dir="auto"
            onClick={goToSearch}
            className="flex justify-center items-center fixed left-[50%] transform translate-x-[-50%] w-[294px] h-[52px] rounded-[74px] bg-gradient-to-r from-[#7DD97F] to-[#16B28D]"
            style={{
              bottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
            }}
          >
            <div
              className="text-white text-center font-sans text-[16px] font-bold leading-[20px]"
              dir="auto"
            >
              {_T('邀请')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
